module.exports = __webpack_public_path__ + "img/1563049799.8bdc5f66.jpg";